import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { LGCImportCard } from "@/uiKit/organisms/PatientSync/PatientSyncIndex/LGCImportCard.tsx";
import { LibreviewImportCard } from "@/uiKit/organisms/PatientSync/PatientSyncIndex/LibreviewImportCard.tsx";

export type PatientSyncPlatformsProps = {
  className?: string;
};

export const PatientSyncPlatforms: React.FC<PatientSyncPlatformsProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <div className={cx(styles.container, className)}>
      <Typography variant="h5">{t("patientSync.index.sectionTitle")}</Typography>
      <div className={styles.cards}>
        <LibreviewImportCard className={styles.card} />
        <LGCImportCard className={styles.card} />
      </div>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(8),
  }),
  cards: css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: theme.spacing(8),
    flexWrap: "wrap",
  }),
  card: css({
    display: "flex",
    flexDirection: "column",
    height: theme.spacing(128),
    width: `max(48%, ${theme.spacing(320)})`,
  }),
});
